import React, { FC } from 'react'
import { Grid, withStyles } from '@material-ui/core'
import { getStyles } from 'isotope-client'
import { QuantiteUcDisplayable, Sortie } from '../services/sortie.types'
import Typography from '@material-ui/core/Typography'
import { LocalDateTime } from '../../../../utils/date/local-date-time'
import { formatDeboucheLabel } from '../services/sortie.utils'
import { FormattedMessage, FormattedDate } from 'react-intl'

const styles = () => getStyles({
	body: {
		margin: '12px 36px 0px 36px',
		gap: 8
	},
	label: {
		marginRight: 4
	},
	bold: {
		fontWeight: 600
	},
	caption: {
		color: '#88888A',
		fontSize: 10,
		fontWeight: 400,
		marginLeft: 4
	},
	commentaire: {
		maxWidth: 316,
		wordBreak: 'break-all' as 'break-all'
	}
})

type SortieDialogBodyProps = {
	sortie: Sortie
	quantiteUcDisplayable: QuantiteUcDisplayable
	showCommentaire?: boolean
	classes: ClassNameMap
}

/**
 * Affichage du détail d'une sortie dans les dialog
 */
const SortieDialogBody: FC<SortieDialogBodyProps> = ({ sortie, quantiteUcDisplayable, showCommentaire = false, classes}) => {
	return <Grid item container className={classes.body} xs={12} justify="center">
		<Grid item container>
			<Typography variant="body2" className={classes.label}><FormattedMessage id="sorties.history.popin.culture" /></Typography>
			<Typography variant="body2" className={classes.bold}>{sortie.culture.nom}</Typography>
		</Grid>
		<Grid item container alignItems="baseline">
			<Typography variant="body2" className={classes.label}><FormattedMessage id="sorties.history.popin.quantite" /></Typography>
			<Typography variant="body2">{sortie.quantite}</Typography>
			<Typography variant="body2" className={classes.caption}>kg</Typography>
		</Grid>
		<Grid item container alignItems="baseline">
			<Typography variant="body2" className={classes.label}><FormattedMessage id="sorties.history.popin.uc" /></Typography>
			<Typography variant="body2">{quantiteUcDisplayable.quantiteUc}</Typography>
			{quantiteUcDisplayable.typeConditionnement && <Typography variant="body2" className={classes.caption}>{quantiteUcDisplayable.typeConditionnement}</Typography>}
		</Grid>
		<Grid item container>
			<Typography variant="body2" className={classes.label}><FormattedMessage id="sorties.history.popin.dateSortie" /></Typography>
			<Typography variant="body2">
				<FormattedDate
					value={LocalDateTime.fromAPI(sortie.dateSortie).jsDate}
					year="numeric"
					month="numeric"
					day="numeric"
					hour="numeric"
					minute="numeric"
				/>
			</Typography>
		</Grid>
		<Grid item container>
			<Typography variant="body2" className={classes.label}><FormattedMessage id="sorties.history.popin.debouche" /></Typography>
			<Typography variant="body2">{formatDeboucheLabel(sortie.debouche)}</Typography>
		</Grid>
		<Grid item container>
			<Typography variant="body2" className={classes.label}><FormattedMessage id="sorties.history.popin.author" /></Typography>
			<Typography variant="body2">{`${sortie.author.firstname} ${sortie.author.lastname}`}</Typography>
		</Grid>
		<Grid item container>
			<Typography variant="body2" className={classes.label}><FormattedMessage id="sorties.history.popin.dateCreation" /></Typography>
			<Typography variant="body2">
				<FormattedDate
					value={LocalDateTime.fromAPI(sortie.dateCreation).jsDate}
					year="numeric"
					month="numeric"
					day="numeric"
					hour="numeric"
					minute="numeric"
				/>
			</Typography>
		</Grid>
		{showCommentaire && <Grid item container>
			<Typography variant="body2" className={classes.label}><FormattedMessage id="sorties.history.popin.commentaire" /></Typography>
			<Typography variant="body2" className={classes.commentaire}>{sortie.commentaire ?? '-'}</Typography>
		</Grid>}
	</Grid>
}

export default withStyles(styles)(SortieDialogBody)